exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-indicator[data-v-5667feed] {\n  color: #ffc107;\n  font-size: 0.9em;\n  margin-left: 8px;\n}\n", ""]);

// exports
